
import {
  defineComponent,
  ref,
  reactive,
  onMounted,
  computed,
} from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'

export default defineComponent({
  components: {
  },

  setup () {
    const showUploadForm = ref(false)
    const router = useRouter()
    const form_action = ref('save')
    const store = useStore()

    const fields = ref([
      {
        title: 'Insertion Order',
        dataIndex: 'insertion_order',
        fixed: 'left'
      },
      {
        title: 'Winame',
        dataIndex: 'winame',
        fixed: 'left'
      },
      {
        title: 'Activity Name',
        dataIndex: 'activity_name',
      },
      {
        title: 'Username',
        dataIndex: 'username'
      },
      {
        title: 'Entry Date Time',
        dataIndex: 'entry_date_time'
      },
      {
        title: 'Exit Date Time',
        dataIndex: 'exit_date_time'
      },
      {
        title: 'Action',
        dataIndex: 'action'
      }
    ])

    const index = (payload = {page: 1}) => {
        store.dispatch('ApTsla/index', payload)
    }

    const filterRecord = (payload: any) => {
        index(payload)
    }
    
    onMounted(index)

    const items = computed(() => store.getters['ApTsla/items'])
    const loading = computed(() => store.getters['ApTsla/status'])


    return {
      items,
      loading,
      fields,
      form_action,
      showUploadForm,
      filterRecord
    }
  },
})
